import { Box, Paper, Stack, Typography } from '@mui/material';
import { TitledResultBox } from './TitledResultBox';
import { possibleLVO, scaleValue } from './TestDetailsModel';
import { ResultRow } from './ResultRow';

export function TestHeader({ testDetails }) {
  return (
    <>
      <Stack alignItems="center">
        <Paper elevation={2} sx={{ padding: '20px', width: '1060px' }}>
          <Stack spacing={2}>
            <Stack direction="row" spacing={2}>
              <Typography variant="h6" color="textPrimary" component="h6">
                Date
              </Typography>
              <Typography variant="h6" color="textPrimary" component="h6">
                {testDetails && testDetails?.createDate?.split('.')[0].replace('T', ' ')}
              </Typography>
            </Stack>
            {testDetails?.finalResult?.fastAIResult && <TitledResultBox title="FASTAI" value={testDetails?.finalResult?.fastAIResult} />}
            {testDetails?.finalResult && <TitledResultBox title={testDetails.finalResult.scaleUsed} value={scaleValue(testDetails?.finalResult)} />}
            {testDetails?.finalResult && (
              <Box sx={{ width: '460px', padding: '5px' }}>
                <ResultRow title="Possible LVO" value={possibleLVO(testDetails?.finalResult)} showBorder={false} />
              </Box>
            )}
          </Stack>
        </Paper>
      </Stack>
    </>
  );
}
